export default function tratarErrosApi(error) {
  if (error?.response?.status >= 400 && error?.response?.status < 500) {
    return error.response.data;
  } else {
    return { __desconhecido: error };
  }
}
